var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/readable-stream/~/isarray/index.js
// module id = ../../../../readable-stream/node_modules/isarray/index.js
// module chunks = 5